import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import AdminBillingNav from '@/components/adminBilling/AdminBillingNav';
import StatusChip from '@/components/adminBilling/StatusChip';
import { adminBillingService } from '@/api/services/adminBilling';
import { formatApiError } from '@/utils/formatApiError';
import { DataTableScrollArea } from '@/components/table';

export default function AdminBillingOrganizationsPage() {
  const [items, setItems] = useState<Record<string, unknown>[]>([]);
  const [search, setSearch] = useState('');
  const [cursor, setCursor] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback((nextCursor?: string | null, q?: string) => {
    adminBillingService
      .organizations({ search: q || undefined, cursor: nextCursor || undefined })
      .then((res) => {
        setItems((prev) => (nextCursor ? [...prev, ...res.items] : res.items));
        setCursor(res.nextCursor ?? null);
        setHasMore(res.hasMore);
      })
      .catch((e) => setError(formatApiError(e)));
  }, []);

  useEffect(() => {
    load(undefined, search);
  }, [load, search]);

  return (
    <div className="admin-billing-page">
      <AdminBillingNav />
      <PageHeader title="Organizations" subtitle="Billing state across all organizations." />
      {error ? <div className="alert alert-error">{error}</div> : null}
      <section className="panel">
        <input
          type="search"
          placeholder="Search organizations…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <DataTableScrollArea>
        <table className="data-table">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Plan</th>
              <th>Provider</th>
              <th>Status</th>
              <th>Expires</th>
            </tr>
          </thead>
          <tbody>
            {items.map((o) => (
              <tr key={String(o.organizationId)}>
                <td>
                  <Link to={`/admin/billing/organizations/${o.organizationId}`}>
                    {String(o.organizationName || o.organizationSlug)}
                  </Link>
                </td>
                <td>{String(o.planSlug || '—')}</td>
                <td>{String(o.provider || '—')}</td>
                <td><StatusChip status={String(o.entitlementStatus || o.status)} /></td>
                <td>{o.expiresAt ? new Date(String(o.expiresAt)).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </DataTableScrollArea>
        {hasMore && cursor ? (
          <button type="button" className="btn btn-secondary" onClick={() => load(cursor, search)}>
            Load more
          </button>
        ) : null}
      </section>
    </div>
  );
}
